export const getCarNameLabel = (car: IProductModel | null) => {
	return car ? car.brand?.toLowerCase() + '_' + car.name?.split(' ')?.join('_')?.toLowerCase() : null
}

export const getCarPricePerDay = (car: IProductModel | null, exchangeRate: string | number = 1) => {
	if (!car) return 0
	const price = car.segment.promotionalPrice?.amountGross ?? car.segment.regularPrice?.amountGross ?? car.segment.pricePerDay
	return (Number(price) * Number(exchangeRate)).toFixed(2)
}

export const getCarPrice = (car: IProductModel | null, exchangeRate: string | number = 1, days: number | null = 1) => {
	if (!car) return 0
	const price = car.segment.promotionalPrice?.amountGross ?? car.segment.regularPrice?.amountGross ?? car.segment.pricePerDay
	return (Number(price) * (days ?? 1) * Number(exchangeRate)).toFixed(2)
}

export const getCarSegmentLabel = (car: IProductModel | null) => {
	if (!car) return null
	return car.segment?.name_en?.split(' ')?.join('_')?.toLowerCase()
}

export const getCarGroups = (car: IProductModel | null) => {
	if (!car) return null
	return car.segment.groups?.map((g) => g?.name?.toLowerCase())
}
